<template>
  <div id="modalPEAKMobile">
    <div class="peakMobileBanner">
      <img class="peakMobileBannerImage" :src="bannerUrl" alt="PEAK Mobile Banner" />
      <div class="closeIcon">
        <i class="icon-close" @click="(HideModal(), $event.stopImmediatePropagation())"></i>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

@Component
export default class ModalPEAKMobile extends Vue {
  private peakFileServer = process.env.VUE_APP_PeakFileServer?.toString() ?? "";

  get bannerUrl() {
    let imagePath = "peakengine/Content/Image/ApplicationStore/";
    switch (this.$i18n.locale) {
      case "en":
        imagePath += "PEAK_Mobile_Banner_En.png";
        break;
      case "th":
      default:
        imagePath += "PEAK_Mobile_Banner_Th.png";
        break;
    }

    return this.peakFileServer.UrlCombine(imagePath);
  }

  public HideModal(): void {
    this.$emit("update:showModal", false);
  }
}
</script>

<style lang="scss" scoped>
#modalPEAKMobile {
  position: relative;
  @include modal;

  .peakMobileBanner {
    position: relative;
    @include animation("mymodalAnimation 0.2s 1 ease-out");

    .peakMobileBannerImage {
      height: min(80vh, 500px);
      border-radius: 16px;
    }

    .closeIcon {
      position: absolute;
      cursor: pointer;
      top: 0;
      right: 0;
      transform: translate(50%, -50%);

      i {
        font-size: 32;
        color: white;
        transition: 0.5s;
        border-radius: 50%;
        color: $text;
        padding: 6px;
        background: white;
      }
    }
  }
}
</style>
